<template>
  <div class="c-app flex-row align-items-center">
    <CContainer style="display: flex; justify-content: center" class="p-0">
      <div class="container-box center">
        <div class="text-left">
          <div class="card-custom-web">
            <br />
            <div class="mb-2">
              <CCard class="ml-3 mr-3" @click="GoToOnlineBanking()">
                <CCardBody>
                  <CRow>
                    <span>
                      <img src="../../assets/img/icon/maybank.svg" />
                      <img src="../../assets/img/icon/bankislam.svg" />
                      <img src="../../assets/img/icon/cimb.svg" />
                      <img src="../../assets/img/icon/publicbank.svg" />
                      <img src="../../assets/img/icon/hsbcbank.svg" />
                      <img src="../../assets/img/icon/uobank.svg" />
                      <img src="../../assets/img/icon/bsnbank.svg" />
                      <img src="../../assets/img/icon/othersbank.svg" />
                    </span>
                    <div>
                      <span>
                        <span
                          style="position: absolute; top: 40px; right: 30px"
                        >
                          <img src="../../assets/img/icon/VectorRight.svg" />
                        </span>
                      </span>
                      <div style="clear: both"></div>
                    </div>
                  </CRow>
                  <span class="title-payment"> Online Banking </span>
                </CCardBody>
              </CCard>
            </div>
            <div style="clear: both"></div>
            <div class="mb-2">
              <CCard class="ml-3 mr-3" @click="GoToCardPayment()">
                <CCardBody>
                  <CRow>
                    <span>
                      <img src="../../assets/img/icon/visa.svg" />
                      <img src="../../assets/img/icon/debit.svg" />
                    </span>
                    <div>
                      <span>
                        <span
                          style="position: absolute; top: 40px; right: 30px"
                        >
                          <img src="../../assets/img/icon/VectorRight.svg" />
                        </span>
                      </span>
                      <div style="clear: both"></div>
                    </div>
                  </CRow>
                  <span class="title-payment"> Credit/Debit </span>
                </CCardBody>
              </CCard>
            </div>
            <div class="mb-2">
              <CCard class="ml-3 mr-3" @click="GoToEWalletPayment()">
                <CCardBody>
                  <CRow>
                    <span>
                      <img src="../../assets/img/icon/boostpay.svg" />
                      <img src="../../assets/img/icon/grabpay.svg" />
                      <img src="../../assets/img/icon/shopeepay.svg" />
                      <img src="../../assets/img/icon/favepay.svg" />
                      <img src="../../assets/img/icon/tngewallet.svg" />
                      <img src="../../assets/img/icon/wechatpay.svg" />
                    </span>
                    <div>
                      <span>
                        <span
                          style="position: absolute; top: 40px; right: 30px"
                        >
                          <img src="../../assets/img/icon/VectorRight.svg" />
                        </span>
                      </span>
                      <div style="clear: both"></div>
                    </div>
                  </CRow>
                  <span class="title-payment"> E-Wallet </span>
                </CCardBody>
              </CCard>
            </div>
          </div>
        </div>
      </div>
    </CContainer>
    <div class="header-top">Select Payment Method</div>
    <div class="header-left">
      <img src="../../assets/img/icon/VectorLeft.svg" />
    </div>
    <div style="clear: both"></div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      DeleteNotification: false,
    };
  },
  methods: {
    // GoToExam(){
    //   this.$router.push(
    //     "/RegisterStudentExam"
    //   );
    // }
    OpenDelete() {
      this.DeleteNotification = true;
    },

    GoToOnlineBanking() {
      this.$router.push("/ParentProfile/OnlineBanking");
    },

    GoToCardPayment() {
      this.$router.push("/ParentProfile/CardPayment");
    },

    GoToEWalletPayment() {
      this.$router.push("/ParentProfile/EWalletPayment");
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");

input {
  border-bottom: 2px solid #dbdbdb;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  width: 90%;
}

input ::placeholder {
  color: #e0e0e0;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #e0e0e0;
}
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
.custom-bg-color {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  /* Clickable/Light */

  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  margin: 0px 20px;
  display: flex;
  justify-content: center;
}
body {
  font-family: "Montserrat", sans-serif;
}

.class-teach-name {
  padding: 4px 1px;
  top: 45px;
  /* height: 40px; */

  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;

  /* Pure/White */

  color: #ffffff;

  /* Inside auto layout */

  /* flex: none;
  order: 0;
  flex-grow: 0; */
}
.custom-btn-add {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;

  color: #007cef;
}
.custom-promo-text {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  align-items: center;

  color: #000a2c;
}
.custom-promo-title {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 29px;

  color: #000a2c;
}
.custom-label-title {
  width: 303px;
  height: 20px;

  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  /* identical to box height */

  /* Blue/Primary */

  color: #007cef;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
}
.title-payment {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  /* identical to box height */

  /* #000A2C */

  color: #000a2c;
}
</style>